export default {
  getDefaultState: () => {
    return {
      transactionFields: [],
      transactionFieldsCurrentPage: 1,
      transactionFieldsLastPage: 1,
      reviewFlows: [],
      currentReviewFlow: {},
      reviewFlowsCurrentPage: 1,
      reviewFlowsLastPage: 1,
      isCallingTransactionFields: false,
      isCallingReviewFlows: false
    }
  }
}
